// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-1ae11bc6]{padding:15px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:880px;height:660px;background-color:#fff;box-shadow:0 0 10px 0 #000}.box h5[data-v-1ae11bc6]{padding-left:30px}.box h5 span[data-v-1ae11bc6]{padding-left:15px}.box .center[data-v-1ae11bc6]{margin:10px auto;width:760px;height:500px}.box .btn1[data-v-1ae11bc6]{float:right}", ""]);
// Exports
module.exports = exports;
